import React, { FC } from "react";
import * as Sentry from "@sentry/react";
import { Route } from "react-router-dom";

const SentryRoute = Sentry.withSentryRouting(Route);

export const CustomRoute: FC<{
  isPrivate?: boolean;
  group?: number;
  role?: number;
  exact: boolean;
  path: string;
  component?: React.FC<{}>;
}> = ({ ...props }) => {
  return <SentryRoute {...props} />;
};
